import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [40.794138, -73.959054, 21.4],
  [40.794058, -73.958926, 21.6],
  [40.793977, -73.958797, 21.6],
  [40.793894, -73.958673, 21.6],
  [40.793816, -73.958545, 21.6],
  [40.793754, -73.958405, 21.8],
  [40.793698, -73.958271, 22],
  [40.793653, -73.958132, 22.2],
  [40.793615, -73.957992, 22.4],
  [40.793591, -73.957858, 22.8],
  [40.793577, -73.957713, 23.2],
  [40.793577, -73.957574, 23.4],
  [40.793588, -73.957445, 23.8],
  [40.793615, -73.957316, 24],
  [40.79365, -73.957193, 24],
  [40.793695, -73.95708, 24],
  [40.793744, -73.956962, 23.8],
  [40.793797, -73.956855, 23.8],
  [40.793859, -73.956742, 23.8],
  [40.793915, -73.95663, 23.8],
  [40.793977, -73.956522, 23.8],
  [40.794039, -73.95642, 24],
  [40.794106, -73.956324, 24.2],
  [40.794176, -73.956233, 24.4],
  [40.79424, -73.956131, 24.8],
  [40.794296, -73.956034, 25.2],
  [40.794342, -73.955932, 25.6],
  [40.794377, -73.955825, 26.4],
  [40.794409, -73.955723, 27],
  [40.794428, -73.955621, 27.8],
  [40.794441, -73.95553, 28.4],
  [40.794449, -73.955439, 28.8],
];

export default stream;
